import React, { useState } from 'react';
import './ContactUs.css';
import Footer from '../../components/Footer/Footer';
import imgss from "../../assets/images/kidss.avif";
import inside1 from '../../assets/shopimage/inim1.jpg'
import inside2 from '../../assets/shopimage/inim2.jpg'
import inside3 from '../../assets/shopimage/inim3.jpg'
import inside4 from '../../assets/shopimage/inim4.jpg'
const stores = [
    {
        name: 'SWARNA',
        location: 'GROUND FLOOR',
        image: inside1, // Replace with actual image paths
    },
    {
        name: 'NEKLACE SECTIONS',
        location: 'SECTION1 GF',
        image: inside2,
    },
    {
        name: 'SILVER SECTIONS',
        location: 'FIRST FLOOR',
        image: inside3,
    },
    {
        name: 'DIAMOND COLLECTIONS',
        location: 'FIRST FLOOR',
        image: inside4,
    },
  ];


const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });


    const handleInputChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        // Handle form submission here
        console.log('Form submitted:', formData);
        // Reset form
        setFormData({
            name: '',
            email: '',
            phone: '',
            subject: '',
            message: ''
        });
        alert('Thank you for your message! We will get back to you soon.');
    };


    return (
        <>
        <div className="contact-container">
            {/* Header Section */}
          
                
                       <img src={imgss} alt="" className='abtimg cuim' />
               
        


            {/* Main Content */}
            <div className="contact-content">
                <div className="container">
                    <div className="contact-wrapper">

                        {/* Left Side - Contact Information */}
                        <div className="contact-left">
                            <div className="contact-info">
                                <h2>Get In Touch</h2>
                                {/* <p className="info-description">
                                    Have questions about our jewelry collection or need assistance?
                                    We're here to help you find the perfect piece.
                                </p> */}


                                <div className="contact-details">
                                    <div className="contact-item">
                                        <div className="contact-icon">
                                            <i className="fas fa-map-marker-alt"></i>
                                        </div>
                                        <div className="contact-text">
                                            <h4>Address</h4>
                                                <p>Swarna Prakash Jewellers<br />Joduraste Karkala<br /> Udupi District - 576117</p>
                                        </div>
                                    </div>


                                    <div className="contact-item">
                                        <div className="contact-icon">
                                            <i className="fas fa-phone"></i>
                                        </div>
                                        <div className="contact-text">
                                            <h4>Phone</h4>
                                                <p>+91 7204429777</p>
                                        </div>
                                    </div>


                                    <div className="contact-item">
                                        <div className="contact-icon">
                                            <i className="fas fa-envelope"></i>
                                        </div>
                                        <div className="contact-text">
                                            <h4>Email</h4>
                                                <p>swarnaprakashjewellers@gmail.com</p>
                                        </div>
                                    </div>


                                    <div className="contact-item">
                                        <div className="contact-icon">
                                            <i className="fas fa-clock"></i>
                                        </div>
                                        <div className="contact-text">
                                            <h4>Business Hours</h4>
                                            <p>Mon - Sat: 10:00 AM - 7:00 PM<br /></p>
                                        </div>
                                    </div>
                                </div>


                                {/* Social Media */}
                             
                            </div>
                        </div>


                        {/* Right Side - Contact Form and Map */}
                        <div className="contact-right">
                            {/* Contact Form */}
                            <div className="contact-form-section">
                                <h2>Send Us A Message</h2>
                                <form className="contact-form" onSubmit={handleSubmit}>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="name"
                                                placeholder="Your Name *"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input
                                                type="email"
                                                name="email"
                                                placeholder="Your Email *"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>


                                    <div className="form-row">
                                        <div className="form-group">
                                            <input
                                                type="tel"
                                                name="phone"
                                                placeholder="Your Phone"
                                                value={formData.phone}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                name="subject"
                                                placeholder="Subject"
                                                value={formData.subject}
                                                onChange={handleInputChange}
                                            />
                                        </div>
                                    </div>


                                    <div className="form-group">
                                        <textarea
                                            name="message"
                                            placeholder="Your Message *"
                                            rows="6"
                                            value={formData.message}
                                            onChange={handleInputChange}
                                            required
                                        ></textarea>
                                    </div>


                                    <button type="submit" className="submit-btn">
                                        Send Message
                                    </button>
                                </form>
                            </div>


                            {/* Map Section */}
                                <div className="social-media">
                                    <h4>Follow Us</h4>
                                  <div className="social-links">
  <a href="https://www.facebook.com/swarnaprakashjewellers/" className="social-link" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-facebook-f"></i>
  </a>
  <a href="https://www.instagram.com/swarnaprakashjewellers/" className="social-link" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-instagram"></i>
  </a>
  <a href="https://g.co/kgs/jeCmuUq" className="social-link" target="_blank" rel="noopener noreferrer">
    <i className="fas fa-map-marker-alt"></i> 
  </a>
  <a href="mailto:swarnaprakashjewellers@gmail.com" className="social-link">
    <i className="fas fa-envelope"></i> 
  </a>
</div>

                                </div>
                          
                        </div>
                    </div>
                        <section className="store-section storecont">
                            <h2 className="store-heading ourc">Visit Our Store</h2>
                            <div className="store-gridc">
                                {stores.map((store, idx) => (
                                    <div className="store-card" key={idx}>
                                        <img src={store.image} alt={store.name} className="store-image" />
                                        <h3 className="store-name">{store.name}</h3>
                                        <p className="store-location">{store.location}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                </div>
                    <div className="map-section container">
                        <h2>Find Us</h2>
                        <div className="map-container">
                            <iframe
                                src=" https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3883.823008166778!2d74.98153227594122!3d13.236421509015132!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bbb5793889c7f99%3A0x1e87cc83240e4c5a!2sSwarna%20Prakash%20Jewellers!5e0!3m2!1sen!2sin!4v1751886410203!5m2!1sen!2sin"
                                width="100%"
                                height="300"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Store Location"
                            ></iframe>
                        </div>
                    </div>
            </div>
                
        </div>


         
        <Footer />
        </>
    );
};


export default ContactUs;
